module.exports = __webpack_public_path__ + "img/thailand.0e37a825.svg";